import React, { useState, useCallback, useEffect } from 'react';
import { Row } from 'reactstrap';
import Loader from 'components/Loader';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import { AnalyticalOpportunityTime } from '../../../../components/Tables/AnalyticalOpportunityTime';
import { SyntheticOpportunityTime } from '../../../../components/Tables/SyntheticOpportunityTime';
import { useListOpportunities } from '../../../hooks/useListOpportunityTime';
import FilterOpportunityTimeForm from '../FilterOpportunityTime';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../../../../../hooks/useMemorizeInputsFilters';

const ReportOpportunityTime = ({
  selectedRecordTypeId,
  setSelectedRecordType,
  recordTypes
}) => {
  const [activePage, setActivePage] = useState(1);
  const [reportType, setReportType] = useState(1);
  const [analyticalData, setAnalyticalData] = useState([]);
  const [syntheticalData, setSyntheticalData] = useState([]);
  const [quantity, setQuantity] = useState(0);
  const [dataToSend, setDataToSend] = useState({});
  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.CRM_OPPORTUNITY_TIME
  );

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  const {
    getReportOpportunityTime,
    opportunities,
    totalOpportunities,
    getReportSyntheticOpportunityTime,
    syntheticData,
    isLoadingOpportunities,
    isLoadingSyntheticOpportunities
  } = useListOpportunities({
    recordTypeId: selectedRecordTypeId,
    sortConfig
  });

  const handleSearch = useCallback(
    (searchFilters, reportTypeSubmit) => {
      const page = searchFilters?.page || 1;
      setReportType(reportTypeSubmit);
      setActivePage(page);
      if (reportTypeSubmit === 1) {
        getReportOpportunityTime(page, searchFilters);
      }

      if (reportTypeSubmit === 2) {
        getReportSyntheticOpportunityTime(page, searchFilters);
      }
      memorizeFilters(searchFilters);
    },
    [getReportOpportunityTime, getReportSyntheticOpportunityTime, memorizeFilters]
  );

  useEffect(() => {
    const storedSortConfig = JSON.parse(localStorage.getItem('flexTableConfig::[opportunitiesTime]')) || { key: null, direction: null };
    const { key, direction } = sortConfig?.key ? sortConfig : storedSortConfig;

    if (!key || !direction) return console.log('A chave e a direção de ordenamento devem ser informadas.');

    handleSearch({
      ...getMemorizedFilters(),
      orderBy: key,
      orderType: direction
    }, reportType);
  }, [sortConfig, handleSearch, reportType, getMemorizedFilters]);

  useEffect(() => {
    if (reportType === 1) {
      if (opportunities && opportunities.length) {
        setAnalyticalData(opportunities);
        setQuantity(totalOpportunities);
      }

      if (opportunities && !opportunities.length) {
        setAnalyticalData(opportunities);
        setQuantity(totalOpportunities);
        toast.info('Nenhum registro foi encontrado');
      }
    }

    if (reportType === 2) {
      if (syntheticData) {
        setSyntheticalData(syntheticData);
      }
    }
  }, [opportunities, totalOpportunities, reportType, syntheticData]);

  const handlePageChange = (page) => {
    const currentFilters = getMemorizedFilters();
    memorizeFilters({ ...currentFilters, page });
    setActivePage(page);
    getReportOpportunityTime(page, dataToSend);
  };

  return (
    <>
      <FilterOpportunityTimeForm
        handleSearch={handleSearch}
        recordTypeId={selectedRecordTypeId}
        opportunities={opportunities}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
        analyticalData={analyticalData}
        setAnalyticalData={setAnalyticalData}
        quantity={quantity}
        setDataToSend={setDataToSend}
        reportType={reportType}
      />

      {reportType === 2 ? <hr /> : null}
      {analyticalData && analyticalData.length > 0 && reportType === 1 ? (
        isLoadingOpportunities ? (
          <div className="col-12">
            <Row className="justify-content-md-center">
              <Loader />
            </Row>
          </div>
        ) : (
          <div style={{ marginTop: '1rem' }}>
            <AnalyticalOpportunityTime data={analyticalData} setSortConfig={setSortConfig} sortConfig={sortConfig} />
            <Pagination
              activePage={activePage}
              totalItemsCount={quantity}
              onChange={handlePageChange.bind(this)}
            />
          </div>
        )
      ) : null}
      {syntheticalData &&
        Object.keys(syntheticalData).length >= 1 &&
        reportType === 2 ? (
        isLoadingSyntheticOpportunities ? (
          <div className="col-12">
            <Row className="justify-content-md-center">
              <Loader />
            </Row>
          </div>
        ) : (
          <div style={{ marginTop: '1rem' }}>
            <SyntheticOpportunityTime data={syntheticalData} />
          </div>
        )
      ) : null}
    </>
  );
};

export default ReportOpportunityTime;